// @ts-nocheck
import styles from './CustomerZoneHome.module.css';

const marketingUrl = import.meta.env.VITE_CZ_MARKETING_URL || 'https://servcraft.co.za';

export default function CustomerZoneFooter() {
  return (
    <footer className={styles.footer}>
      <p className={styles.footPowered}>
        Powered by&nbsp;
        <img
          src="/logo-type-blue.svg"
          alt="ServCraft"
          onError={(e: any) => { e.target.style.display = 'none'; }}
        />
      </p>
      <p className={styles.footPitch}>
        SA&rsquo;s&nbsp;#1 software for trade businesses. ServCraft pulls every job, team, and payment
        together, so nothing slips and you&rsquo;re not chasing.
      </p>
      <p className={styles.footCta}>
        <a href={marketingUrl} target="_blank" rel="noopener noreferrer">
          Find out more about ServCraft →
        </a>
      </p>
      <p className={styles.footSupport}>
        Need support? Contact us at{' '}
        <a href="mailto:support@servcraft.co.za">support@servcraft.co.za</a>
      </p>
    </footer>
  );
}
